import { fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'

import { IAdminMSTeamsWelcome } from './interface'
import { AdminMSTeamsWelcomeRecord } from 'store/records/adminMSTeamsWelcome'
import { getAdminMSTeamsWelcome, createAdminMSTeamsWelcome, updateAdminMSTeamsWelcome } from './actions'

export const initialState = fromJS({
  data: new AdminMSTeamsWelcomeRecord(),
  pending: false,
}) as IAdminMSTeamsWelcome

const handleGetAdminMSTeamsWelcomeSuccess = (state: any, { payload }: any) => {
  if (payload.data) {
    return state.set('data', payload.data).set('pending', false)
  }
  return state.set('data', new AdminMSTeamsWelcomeRecord()).set('pending', false)
}

const handleAdminMSTeamsWelcome = (state: any) => {
  return state.set('pending', true)
}

const handleAdminMSTeamsWelcomeFail = (state: any) => {
  return state.set('pending', false)
}

const handleCreateAdminMSTeamsWelcomeSuccess = (state: any, { payload }: any) => {
  return state.set('data', new AdminMSTeamsWelcomeRecord(payload.data)).set('pending', false)
}

const handleUpdateAdminMSTeamsWelcomeSuccess = (state: any, { payload }: any) => {
  return state.setIn('data', payload.data).set('pending', false)
}

export default handleActions(
  {
    [getAdminMSTeamsWelcome.success as any]: handleGetAdminMSTeamsWelcomeSuccess,
    [createAdminMSTeamsWelcome.success as any]: handleCreateAdminMSTeamsWelcomeSuccess,
    [updateAdminMSTeamsWelcome.success as any]: handleUpdateAdminMSTeamsWelcomeSuccess,
    [updateAdminMSTeamsWelcome.fail as any]: handleAdminMSTeamsWelcomeFail,
    [combineActions(
      getAdminMSTeamsWelcome.fail,
      createAdminMSTeamsWelcome.fail,
      updateAdminMSTeamsWelcome.fail
    ) as any]: handleAdminMSTeamsWelcomeFail,
    [combineActions(getAdminMSTeamsWelcome, createAdminMSTeamsWelcome, updateAdminMSTeamsWelcome) as any]:
      handleAdminMSTeamsWelcome,
  },
  initialState as any
)
